module.exports = __webpack_public_path__ + "img/envios.5acb54f8.svg";